import React, { Component } from "react";
import { connect } from "react-redux";

import { MessageBar, MessageBarType } from '@fluentui/react';

import "./AppLayout.css"

/**
 * Define the module that needs to be rendered
 * renderBreadcrumb : can be empty
 */
type AppLayoutProps = {
  renderBreadcrumb?: () => JSX.Element;
  renderContentPane: () => JSX.Element;
};

/**
 * used by curation filter Editor page, in this page, we will don't show the scroll
 */
interface ICustomProps {
  containerClassName?: string
}

const sonci_Env = process.env.REACT_APP_SONIC_ENV

/**
 * A basic page structure
 */
const AppLayout  = (props: AppLayoutProps & ICustomProps) => {

  const onDismiss = () => {
    return;
  };



  const render = () => {
    const appContainer = props.containerClassName ? "appContainer filter" : "appContainer"
    return (
      <div className={appContainer}>
        <div>
          {
            sonci_Env === "prod" || sonci_Env === "dev"  ?
              null :
              // <MessageCard
              //   className="useTerms"
              //   severity={MessageCardSeverity.Warning}
              // >
              //   {
              //     "The content data used on the website is extracted from Automated Content Curation Tool UAT data mart in UDP and is provided only for your trial of the functionality of this website. Do not share a copy of the data. Do not copy/paste data into other files."
              //   }
              // </MessageCard>
            <MessageBar
              className="useTerms"
              messageBarType={MessageBarType.warning}
              isMultiline={true}
            >
              The content data used on the website is extracted from Automated Content Curation Tool UAT data mart in UDP and is provided only for your trial of the functionality of this website. Do not share a copy of the data. Do not copy/paste data into other files.
            </MessageBar>
          }        
        </div>
        <div className="appRoot">
          {props.renderBreadcrumb && props.renderBreadcrumb()}
          {props.renderContentPane()}
        </div>
      </div>
    );
  }

  return render()
}

export default AppLayout;